import { LayoutContext as LC } from '@bpmn-io/properties-panel';
import type { Context } from '@bpmn-io/properties-panel/preact';
import type { get } from 'min-dash';

type GetParams = Parameters<typeof get>;

export const LayoutContext = LC as Context<{
    layout: {};
    getLayoutForKey: <T>(path: GetParams[1], defaultValue?: T) => T;
}>;
